import Routes from './routes';
import Header from './components/Header';

import { UserStorage } from './context/UserContext';

const App = () => {
  return (
    <UserStorage>
      <Header />
      <Routes />
    </UserStorage>
  );
};

export default App;
